














































































import { Prop, Component, Vue } from 'vue-property-decorator';
import { IMatrix, IPos, colors } from '@/misc';
import SvgGrid from './SvgGrid.vue';
import SvgTarget from './SvgTarget.vue';
import SvgArrow from './SvgArrow.vue';
import SvgDragPoint from './SvgDragPoint.vue';
import DragHandler from '../DragHandler';

@Component({
  components: {
    SvgGrid,
    SvgTarget,
    SvgArrow,
    SvgDragPoint,
  },
})
export default class SvgGraph extends Vue {
  public colors = colors;
  public aspectRatio = 100;

  @Prop() protected width!: number;
  @Prop() protected height!: number;
  @Prop() protected positionTop!: number;
  @Prop() protected posOrigin!: IPos;
  @Prop() protected matrix!: IMatrix;
  @Prop() protected onMove!: (diff: Partial<IMatrix>) => void;
  @Prop() protected onEnd!: () => void;
  @Prop() protected onOriginMove!: (diff: IPos) => void;
  @Prop() protected onOriginMoveEnd!: () => void;
  @Prop() protected pointIndicatorVisible!: boolean;

  protected dragging = false;
  protected dragHandler = new DragHandler();

  // origin
  protected get ox() { return this.posOrigin.x; }
  protected get oy() { return this.posOrigin.y; }

  // vector i
  protected get ix() { return this.matrix.ix; }
  protected get iy() { return this.matrix.iy; }

  // vector j
  protected get jx() { return this.matrix.jx; }
  protected get jy() { return this.matrix.jy; }

  // translation
  protected get tx() { return this.matrix.tx; }
  protected get ty() { return this.matrix.ty; }

  public mounted() {
    this.dragHandler.start({
      el: this.$el,
      onEnd: (diff) => this.onOriginMoveEnd(),
      onMove: (diff) => this.onOriginMove(diff),
      onStart: (data) => this.onOriginMoveStart(data),
    });
  }

  public destroyed() {
    this.dragHandler.stop();
  }

  public onOriginMoveStart(data: { event: MouseEvent | TouchEvent, stop: () => void }) {
    if (data.event.target !== this.$el) {
      data.stop();
    }
  }

  public t_onMove(diff: IPos) {
    this.dragging = true;
    this.onMove({
      tx: diff.x,
      ty: diff.y,
    });
  }

  public i_onMove(diff: IPos) {
    this.dragging = true;
    this.onMove({
      ix: diff.x / this.aspectRatio,
      iy: diff.y / this.aspectRatio,
    });
  }

  public j_onMove(diff: IPos) {
    this.dragging = true;
    this.onMove({
      jx: diff.x / this.aspectRatio,
      jy: diff.y / this.aspectRatio,
    });
  }

  public onDragEnd(diff: IPos) {
    this.onEnd();
    this.dragging = false;
  }
}
